"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('degree-hat', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("g", {
    stroke: "none",
    strokeWidth: props.strokeWidth,
    fill: "none",
    fillRule: "evenodd"
  }, _react.default.createElement("g", null, _react.default.createElement("g", {
    transform: "translate(2.000000, 9.000000)",
    stroke: props.outStrokeColor,
    strokeLinejoin: props.strokeLinejoin,
    strokeWidth: props.strokeWidth
  }, _react.default.createElement("polygon", {
    fill: props.outFillColor,
    fillRule: "nonzero",
    points: "0 8.4 21.0222222 0 42.0444444 8.4 21.0222222 16.8"
  }), _react.default.createElement("path", {
    d: "M42.0444444,8.51011363 L42.0444444,17.7333333",
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M9.55555556,12.8253553 L9.55555556,25.2666667 C12.7622728,28.4222222 16.584495,30 21.0222222,30 C25.4599494,30 29.2821717,28.4222222 32.4888889,25.2666667 L32.4888889,12.8253553",
    strokeLinecap: props.strokeLinecap
  })))));
});

exports.default = _default;